<template>
	<div class="department-assign">
		<managing-section>
			<managing-box title="부서명">
				<input
					v-if="modalType === 'add' || modalType === 'modify'"
					type="text"
					ref="departmentInput"
					v-model="department"
				/>
				<select
					class="select"
					v-else
					ref="departmentSelect"
					v-model="department"
				>
					<option
						v-for="item in departmentList"
						:key="item.id"
						:value="item.id"
						:disabled="item.id === null"
					>
						{{ item.name }}
					</option>
				</select>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button
				class="btn-main"
				type="button"
				@click="$store.commit('modal/toggleModal', {})"
			>
				닫기
			</button>
			<button
				class="btn-main blue"
				type="button"
				v-if="modalType === 'add'"
				@click="add"
			>
				추가
			</button>
			<button
				class="btn-main blue"
				type="button"
				v-else-if="modalType === 'modify'"
				@click="modify"
			>
				수정
			</button>
			<button class="btn-main blue" type="button" v-else @click="assgin">
				지정
			</button>
		</div>
	</div>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';

	export default {
		name: 'DepartmentAssign',
		components: { ManagingSection, ManagingBox },
		data() {
			return {
				department: null,
			};
		},
		computed: {
			...mapState({
				params: state => state.modal.params,
			}),
			...mapGetters(['getListAddNull']),
			modalType() {
				const params = this.params;
				return params ? params.type : '';
			},
			commonText() {
				const params = this.params;
				return params ? params.commonText : '';
			},
			departmentList() {
				return this.getListAddNull(
					'department',
					null,
					'부서명을 입력하세요'
				);
			},
		},
		mounted() {
			this.$nextTick(() => {
				switch (this.modalType) {
					case 'add':
						this.$refs.departmentInput.focus();
						return;
					case 'modify':
						this.department = this.commonText;
						this.$refs.departmentInput.focus();
						return;
				}
			});
		},
		methods: {
			async add() {
				try {
					const commonText = this.department;
					if (!commonText) {
						alert('부서명은 필수입력값 입니다.');
						this.$refs.departmentInput.focus();
						return;
					}
					await this.$axiosSupport.post('/admin/department', {
						commonText,
					});
					location.reload();
				} catch (err) {
					console.error(err);
					alert(
						'부서를 추가하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async modify() {
				try {
					if (
						!confirm(
							`정말 부서명 "${this.department}" 으로 변경 하시겠습니까?`
						)
					)
						return;
					await this.$axiosSupport.put(
						`/admin/department/${this.params.idCommon}`,
						{
							commonText: this.department,
						}
					);
					location.reload();
				} catch (err) {
					console.error(err);
					alert(
						'부서를 수정하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async assgin() {
				try {
					if (!this.department) {
						alert('부서를 선택해주세요');
						this.$refs.departmentSelect.focus();
						return;
					}
					const params = {
						adminAccount: { department: this.department },
					};
					await this.$axiosSupport.put(
						`/admin/adminAccount/${this.params.idRegister}`,
						params
					);
					location.reload();
				} catch (err) {
					console.error(err);
					alert(
						'부서를 지정하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
		},
	};
</script>
